import parsley from "parsleyjs";
import { URLASSOLUTO, CURRENTLANG } from "./variables";

window.parsley = parsley;

(function () {
    "use strict";
    window.addEventListener(
        "load",
        function () {
            // CAPTCHA
            /*
            window.Parsley.addAsyncValidator(
                "controllaCaptcha",
                function (xhr) {
                    var response = xhr.responseText;
                    if (response === "true") {
                        return true;
                    } else {
                        return false;
                    }
                },
                URLASSOLUTO + "/checkCaptcha.php"
            );
            */
            if (CURRENTLANG == "") {
                Parsley.addMessages("it", {
                    defaultMessage: "Questo valore sembra essere non valido.",
                    type: {
                        email: "Questo valore deve essere un indirizzo email valido.",
                        url: "Questo valore deve essere un URL valido.",
                        number: "Questo valore deve essere un numero valido.",
                        integer: "Questo valore deve essere un numero valido.",
                        digits: "Questo valore deve essere di tipo numerico.",
                        alphanum:
                            "Questo valore deve essere di tipo alfanumerico.",
                    },
                    notblank: "Questo valore non deve essere vuoto.",
                    required: "Questo valore è richiesto.",
                    pattern: "Questo valore non è corretto.",
                    min: "Questo valore deve essere maggiore di %s.",
                    max: "Questo valore deve essere minore di %s.",
                    range: "Questo valore deve essere compreso tra %s e %s.",
                    minlength:
                        "Questo valore è troppo corto. La lunghezza minima è di %s caratteri.",
                    maxlength:
                        "Questo valore è troppo lungo. La lunghezza massima è di %s caratteri.",
                    length: "La lunghezza di questo valore deve essere compresa fra %s e %s caratteri.",
                    mincheck: "Devi scegliere almeno %s opzioni.",
                    maxcheck: "Devi scegliere al più %s opzioni.",
                    check: "Devi scegliere tra %s e %s opzioni.",
                    equalto: "Questo valore deve essere identico.",
                    euvatin: "Non è un codice IVA valido",
                });
                Parsley.setLocale("it");
            } else if (CURRENTLANG == "de") {
                Parsley.addMessages("de", {
                    defaultMessage:
                        "Die Eingabe scheint nicht korrekt zu sein.",
                    type: {
                        email: "Die Eingabe muss eine gültige E-Mail-Adresse sein.",
                        url: "Die Eingabe muss eine gültige URL sein.",
                        number: "Die Eingabe muss eine Zahl sein.",
                        integer: "Die Eingabe muss eine Zahl sein.",
                        digits: "Die Eingabe darf nur Ziffern enthalten.",
                        alphanum: "Die Eingabe muss alphanumerisch sein.",
                    },
                    notblank: "Die Eingabe darf nicht leer sein.",
                    required: "Dies ist ein Pflichtfeld.",
                    pattern: "Die Eingabe scheint ungültig zu sein.",
                    min: "Die Eingabe muss größer oder gleich %s sein.",
                    max: "Die Eingabe muss kleiner oder gleich %s sein.",
                    range: "Die Eingabe muss zwischen %s und %s liegen.",
                    minlength:
                        "Die Eingabe ist zu kurz. Es müssen mindestens %s Zeichen eingegeben werden.",
                    maxlength:
                        "Die Eingabe ist zu lang. Es dürfen höchstens %s Zeichen eingegeben werden.",
                    length: "Die Länge der Eingabe ist ungültig. Es müssen zwischen %s und %s Zeichen eingegeben werden.",
                    mincheck: "Wählen Sie mindestens %s Angaben aus.",
                    maxcheck: "Wählen Sie maximal %s Angaben aus.",
                    check: "Wählen Sie zwischen %s und %s Angaben.",
                    equalto: "Dieses Feld muss dem anderen entsprechen.",
                });

                Parsley.setLocale("de");
            } else if (CURRENTLANG == "en") {
                Parsley.addMessages("en", {
                    defaultMessage: "This value seems to be invalid.",
                    type: {
                        email: "This value should be a valid email.",
                        url: "This value should be a valid url.",
                        number: "This value should be a valid number.",
                        integer: "This value should be a valid integer.",
                        digits: "This value should be digits.",
                        alphanum: "This value should be alphanumeric.",
                    },
                    notblank: "This value should not be blank.",
                    required: "This value is required.",
                    pattern: "This value seems to be invalid.",
                    min: "This value should be greater than or equal to %s.",
                    max: "This value should be lower than or equal to %s.",
                    range: "This value should be between %s and %s.",
                    minlength:
                        "This value is too short. It should have %s characters or more.",
                    maxlength:
                        "This value is too long. It should have %s characters or fewer.",
                    length: "This value length is invalid. It should be between %s and %s characters long.",
                    mincheck: "You must select at least %s choices.",
                    maxcheck: "You must select %s choices or fewer.",
                    check: "You must select between %s and %s choices.",
                    equalto: "This value should be the same.",
                    euvatin: "It's not a valid VAT Identification Number.",
                });

                Parsley.setLocale("en");
            }

            $("#sendwork").parsley();
            $("#sendcontact").parsley();
        },
        false
    );
})();
